import React, { ReactNode, useState } from 'react';
import styled from 'styled-components';
import { v4 as uuidv4 } from 'uuid';

const Wrap = styled.div<{ disabled: boolean }>`
  input {
    display: none;
  }
  label {
    width: 100%;
    text-align: center;
    display: inline-block;
    position: relative;
    padding: 12px 40px;
    background: var(--primary2);
    outline: none;
    border: none;
    border-radius: 2px;
    color: var(--white);
    text-transform: uppercase;
    font-size: var(--medium);
    font-weight: bold;
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};

    &:hover,
    &:focus {
      ${({ disabled }) =>
        disabled ? '' : 'background-color: var(--primary4)'};
    }
    &:active {
      background-color: var(--primary2);
    }
  }

  .isBinanceChainTheme & label {
    color: var(--lightBlack);
  }

  ${({ disabled }) => (disabled ? 'opacity: 0.4;' : '')}
`;

type Props = {
  title: ReactNode;
  onChange: (file: File) => void;
  disabled?: boolean;
};

const FileInput = ({ title, onChange, disabled }: Props) => {
  const [uuid] = useState(uuidv4());
  return (
    <Wrap disabled={!!disabled}>
      <label htmlFor={uuid}>{title}</label>
      <input
        id={uuid}
        type="file"
        disabled={!!disabled}
        onChange={
          disabled
            ? undefined
            : event => {
                if (!event.target.files || event.target.files.length <= 0) {
                  return;
                }
                onChange(event.target.files[0]);
              }
        }
      />
    </Wrap>
  );
};

export default FileInput;
